import React from 'react';

class WizardItemSingleIcon extends React.Component {

	constructor(props) {

		super(props);
		this.state = {
			selected: ""
		};

		this.selectOption = this.selectOption.bind(this);
		this.setInputType = this.setInputType.bind(this);
	}

	componentWillMount() {
		if (this.props.data.ItemType === 'SingleIcon') {
			this.setState({ selected: "" });
		}
		else {
			this.setState({ selected: [] });
		}
	}

	componentDidUpdate() {
		if ((this.state.selected !== "" && this.props.data.ItemType === 'SingleIcon') && ((this.props.previousQuestion > this.props.currentStep) && (this.props.data.Buttons.HideButtonsBelowQuestion && (this.props.goToRev && (this.props.currentStep === this.props.data.CurrentItem - 1))))) {
			this.setState({ selected: "" })
		}
		this.props.setRev(false);
	}

	selectOption(e) {
		let id = e.target.value;

		if (this.props.data.ItemType === 'SingleIcon') {
			this.setState({ selected: id });
			this.props.submitAnswer(id);
		}

		else {
			let newSelected = Object.assign([], this.state.selected);

			if (newSelected.indexOf(id) !== -1) {
				newSelected = newSelected.filter(e => e !== id);
				if (newSelected.length === 0) {
					newSelected = "";
				}
				this.setState({ selected: newSelected });
				this.props.submitAnswer(newSelected);
			}
			else {
				newSelected.push(id);
				this.setState({ selected: newSelected });
				this.props.submitAnswer(newSelected);
			}
		}
	}

	setInputType() {
		if (this.props.data.ItemType === 'MultipleIcons') {
			return "checkbox";
		} else {
			return "radio";
		}
	}

	render() {
		const useTag = '<use xlink:href="/dist/svgsprite/icons.svg#Checkmark_16x16"/>';
		const inputType = this.setInputType();
		const isBrowser = (typeof window !== "undefined");

		return (
			<div className="wizard-item wizard-item__single-icon">

				<input type="hidden" data-trackingid={this.props.data.QuestionTrackingId} value={this.state.selected} />

				{this.props.data.Options.map(
					(option, idx) => {
						return (
							<div className="option" key={idx} >
								<input
									type={inputType}
									name={"inp-" + this.props.data.Id}
									id={"rb-" + option.Id}
									value={option.Id}
									onClick={this.selectOption}
									checked={(this.state.selected.indexOf(option.Id) !== -1)}
								/>
								<label htmlFor={"rb-" + option.Id}>
									<div className="checkmarker">
										<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" dangerouslySetInnerHTML={{ __html: useTag }} />
									</div>
									{option.Icon &&
										<div className="icon" dangerouslySetInnerHTML={{ __html: option.Icon.LargeIcon }} />
									}

									<div className="text">
										<h3 className="headline">{option.Header}</h3>
										<p className="bodycopy">{option.SubHeader}</p>
									</div>
								</label>
							</div>
						)
					}
				)}

			</div>
		)
	}
}

export default WizardItemSingleIcon;